import { createSlice } from "@reduxjs/toolkit";
import {
  getProgramsAsync,
  getProgramByIdAsync,
} from "./actions";

const initialState = {
  isLoading: true,
  current: null,
  all: [],
};

export const programsSlice = createSlice({
  name: "programs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProgramsAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getProgramsAsync.fulfilled, (state, action) => {
        state.all = action.payload;
        state.isLoading = false;
      })
      .addCase(getProgramsAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.all = [];
      })
      .addCase(getProgramByIdAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getProgramByIdAsync.fulfilled, (state, action) => {
        state.current = action.payload;
        state.isLoading = false;
      })
      .addCase(getProgramByIdAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.current = null;
      });
  },
});

export default programsSlice.reducer;
